import React from "react";
import { useUpdatePage } from "core/hooks";
import { currencyString } from "core/lib";
import { dateWrapper } from "core/lib/date.wrapper";
import { PaymentStatusResponseDetail } from "core/services/cef/payment.service";
import { AmountWithCurrency } from "core/services/cef/types";

const MahPaymentResult = ({ response }: { response: PaymentStatusResponseDetail }) => {
    const [updateTitle,] = useUpdatePage();

    const status = response.status.toTitleCase();

    updateTitle(`- Payment: ${status}`);
    const amount = currencyString(response.amount as AmountWithCurrency) ?? "";
    const date = dateWrapper(response.date).shortDate;

    const Line = ({ label, value }: { label: string, value: string }) => {
        return (
            <>
                <dt>{label}</dt>
                <dd>{value}</dd>
            </>
        )
    }

    const icon = "icon-" + status.toLowerCase();

    return (
        <>
            {<i className={`result-icon ${icon}`}></i>}

            <h1>Payment {status}</h1>

            <dl>
                <Line label="Transaction Id" value={response.transactionId} />
                <Line label="Amount" value={amount} />
                <Line label="Status" value={status} />
                <Line label="Date" value={date} />
            </dl>
        </>
    )
}

export default MahPaymentResult;
